/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../store/useAuth";
import { ComponentType, useEffect } from "react";

// Stricter than withAdminPermission: excludes STORE_ADMIN(5), only ADMIN(1)
// and SUPER_ADMIN(7).
export const withSuperAdminPermission = (
  WrappedComponent: ComponentType<any>
) => {
  return function WithSuperAdminPermission(props: JSX.IntrinsicAttributes) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const isAllowed = [1, 7].includes(user?.user_role ?? -1);

    useEffect(() => {
      if (!isAllowed) {
        navigate(-1);
      }
    }, [isAllowed]);

    if (!isAllowed) return null;
    return <WrappedComponent {...props} />;
  };
};
